import { Box, styled } from "@mui/material";

export const SettingsExample = styled(Box)({
    width: "80px",
    height: "70px",
    borderRadius: "5px",
    marginLeft: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "svg": {
        width: "40px",
        height: "40px",
    },
});

